import IUserOutput from '../model/IUser';

type EmailScreenPriority = 'problem' | 'delete' | 'warning' | null;


export function getEmailScreenPriority(user:  IUserOutput | null): EmailScreenPriority {
    if (user?.last_email_error !== null) return 'problem';
    if (user?.confirm_email_deadline !== null) return 'delete';
    if (user && !user.email_confirmed) return 'warning';
    return null;
}